<template>
  <div>
    <a-form :form="form" @submit="handleSubmit">
      <a-form-item
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
        label="项目名称"
        style="margin-top: 20px"
      >
        <a-input
          v-decorator="[
            'projectName',
            { rules: [{ required: true, message: '请输入项目名称' }] },
          ]"
          placeholder="请输入项目名称"
        />
      </a-form-item>
      <a-form-item
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
        label="业主名称"
      >
        <a-input
          v-decorator="[
            'userName',
            { rules: [{ required: true, message: '请输入业主名称' }] },
          ]"
          placeholder="请输入业主名称"
        />
      </a-form-item>
      <a-form-item
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
        label="联系电话"
      >
        <a-input
          v-decorator="[
            'phone',
            {
              rules: [
                { required: true, message: '请输入联系电话' },
                {
                  trigger: 'blur',
                  pattern: new RegExp(/^[1][3,4,5,6,7,8,9][0-9]{9}$/),
                  message: '正确输入手机号',
                },
              ],
            },
          ]"
          placeholder="请输入联系电话"
        />
      </a-form-item>
      <a-form-item
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
        label="工程地址"
      >
        <a-cascader
          :options="options"
          :load-data="loadData"
          placeholder="请选择"
          change-on-select
          :field-names="{ label: 'name', value: 'id', children: 'areaList' }"
          @change="onChange"
          v-decorator="[
            'projectLocation',
            {
              rules: [
                {
                  type: 'array',
                  required: true,
                  message: '请选择地址',
                },
              ],
            },
          ]"
        />
      </a-form-item>
      <a-form-item
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
        label="详细地址"
      >
        <a-input
          v-decorator="[
            'project_detailed_address',
            { rules: [{ required: true, message: '请输入详细地址' }] },
          ]"
          placeholder="请输入详细地址"
        />
      </a-form-item>
      <div v-if="amallShopType == 1">
        <a-form-item
          label="施工商品"
          :label-col="{ span: 3 }"
          :wrapper-col="{ span: 21 }"
          v-show="btnState !== 'edit'"
        >
          <a-button
            :style="{ background: 'var(--amall-green)', color: '#fff' }"
            @click="addPeople"
          >
            搜索
          </a-button>
          <span>（选择商品规格）</span>
        </a-form-item>
      </div>

      <div class="shopContent">
        <div class="shopBox" v-for="(item, index) in shoopList" :key="index">
          <div class="delete" @click="deleteGoods(index, item)">X</div>
          <div style="width: 80px; height: 80px; margin-right: 14px">
            <img
              :src="item.goods_image"
              alt=""
              style="width: 100%; height: 100%"
            />
          </div>
          <div class="shopRight">
            <div style="word-wrap: break-word">{{ item.goods_name }}</div>
            <div>
              <a-select
                label-in-value
                style="width: 160px"
                @change="(...params) => handleChange(index, params)"
              >
                <a-select-option
                  v-for="i in item.specList"
                  :key="i.spec_id"
                  :value="i.spec_id"
                >
                  {{ i.spec_name }}
                </a-select-option>
              </a-select>
            </div>
          </div>
        </div>
      </div>
      <a-form-item
        label="设备材料清单"
        :label-col="{ span: 3 }"
        :wrapper-col="{ span: 21 }"
        v-show="btnState !== 'edit'"
      >
        <a-button
          :style="{ background: 'var(--amall-green)', color: '#fff' }"
          @click="openEqu"
          >添加/修改</a-button
        >
        <!-- <div
          v-show="equipmentData.length || materialData.length"
          class="equstyle"
        > -->
        <div v-show="equipmentData.length">
          <a-table
            :columns="equipmentColumns"
            :data-source="equipmentData"
            :pagination="false"
            style="margin-bottom: 20px"
          />
        </div>
        <div v-show="materialData.length">
          <a-table
            :columns="materialColumns"
            :data-source="materialData"
            :pagination="false"
          />
        </div>
        <!-- </div> -->
      </a-form-item>
      <a-form-item
        label="工程简介"
        :label-col="{ span: 3 }"
        :wrapper-col="{ span: 21 }"
      >
        <wange-ditor
          v-on:get_editor="get_editor_value"
          v-model="editor_value"
          :content="editor_value"
          width="631"
        ></wange-ditor>
      </a-form-item>
      <a-form-item
        label="合同"
        :label-col="{ span: 3 }"
        :wrapper-col="{ span: 21 }"
      >
        <a-upload
          name="image"
          list-type="picture-card"
          action="/api/amall_tools/aliyun/putImages"
          :before-upload="beforeUpload"
          @change="uploadBannerImg"
          :file-list="fileList"
          :remove="handleRemove"
          multiple
          @preview="handlePreview"
        >
          <!-- <div v-if="fileList.length < 9"> -->
            <a-icon
              type="file-image"
              style="font-size: 48px; color: var(--amall-green)"
            />
          <!-- </div> -->
        </a-upload>

        <!-- banner 预览 -->
        <a-modal
          :visible="previewVisible"
          :footer="null"
          @cancel="handleCancel"
          :bodyStyle="{ zIndex: 999999999999 }"
        >
          <img alt="example" style="width: 100%" :src="previewImage" />
        </a-modal>
      </a-form-item>
      <a-form-item label="施工图纸" :label-col="{ span: 3 }">
        <a-button
          :style="{ background: 'var(--amall-green)', color: '#fff' }"
          @click="addDrawing"
          >添加</a-button
        >
        <div class="drawings">
          <div
            v-show="true"
            v-for="(item, index) in DrawingsList"
            :key="index"
            class="drawBox"
            style="width: 192px"
          >
            <div class="deletedrawings" @click="deleteDraw(index)">X</div>
            <a-input placeholder="请输入名称" width="20%" v-model="item.name" />
            <!-- @change="uploadDrawings" -->
            <a-upload
              name="image"
              list-type="picture-card"
              action="/api/amall_tools/aliyun/putImages"
              :before-upload="beforeUpload"
              :showUploadList="{ showRemoveIcon: false }"
              @change="(...parmams) => uploadDrawings(parmams, item)"
              :file-list="item.bulidfileList"
              @preview="handlePreview"
            >
              <div v-if="item.bulidfileList.length < 1">
                <a-icon
                  type="file-image"
                  style="font-size: 48px; color: var(--amall-green)"
                />
              </div>
            </a-upload>

            <!-- banner 预览 -->
            <a-modal
              :visible="previewVisible"
              :footer="null"
              @cancel="handleCancel"
              :bodyStyle="{ zIndex: 999999999999 }"
            >
              <img alt="example" style="width: 100%" :src="previewImage" />
            </a-modal>
            <!-- <button class="delereDraw">删除</button> -->
          </div>
        </div>
      </a-form-item>
      <a-form-item
        label="关联客户"
        :label-col="{ span: 3 }"
        :wrapper-col="{ span: 21 }"
        v-show="btnState !== 'edit'"
      >
        <a-button
          :style="{ background: 'var(--amall-green)', color: '#fff' }"
          @click="visibleUser = true"
        >
          搜索
        </a-button>
        <!-- <a-col :span="21"
          ><a-input
            v-decorator="['choiceUserInfo']"
            placeholder="请输入关联客户"
        /></a-col>
        <a-col :span="2"
          ></a-col
        > -->
      </a-form-item>
      <div style="margin-left: 106px">
        <img
          :src="choiceUserInfo ? choiceUserInfo.ico : ''"
          alt=""
          style="width: 42px"
        />
        {{ choiceUserInfo ? choiceUserInfo.username : "" }}
      </div>
      <a-form-item
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
        label="平台/订单号"
        v-if="btnState !== 'edit'"
      >
        <a-input
          v-decorator="['order_id', { rules: [] }]"
          placeholder="请输入订单号"
        />
      </a-form-item>
      <a-form-item style="margin-left: 106px" v-if="btnState !== 'edit'">
        <a-radio-group v-model="third_party_order_source" button-style="solid">
          <a-radio-button value="1"> 天猫 </a-radio-button>
          <a-radio-button value="2"> 京东 </a-radio-button>
          <a-radio-button value="3"> 淘宝 </a-radio-button>
          <a-radio-button value="4"> A猫商城 </a-radio-button>
          <a-radio-button value="5"> 线下 </a-radio-button>
        </a-radio-group>
      </a-form-item>
      <!-- 编辑的时候显示第三方订单 -->
      <a-form-item
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
        label="平台/订单号"
        v-if="btnState == 'edit'"
      >
        <div v-for="(item, index) in relateThirdPartyOrderList" :key="index">
          <span>{{ item.third_party_order_source_name }}</span>
          <span>{{ item.third_party_order_id }}</span>
        </div>
      </a-form-item>

      <a-form-item style="margin-left: 106px">
        <a-button
          v-show="btnState !== 'edit'"
          :style="{ background: 'var(--amall-green)', color: '#fff' }"
          html-type="submit"
          >下一步</a-button
        >
        <a-button
          v-show="btnState == 'edit'"
          :style="{ background: 'var(--amall-green)', color: '#fff' }"
          html-type="submit"
          >确认</a-button
        >
      </a-form-item>
    </a-form>
    <!-- 设备材料弹窗 -->
    <equmate ref="equmate" @closeDialog="closeDialog" @passData="getmaterial" />
    <!-- 选择商品弹窗 -->
    <searchProduct
      ref="searchDia"
      :single="false"
      :title="dialogTit"
      :dialogType="dialogType"
      :selectedid="selectedid"
      :status="1"
      @confirm="SearchConfirm_compile"
    ></searchProduct>

    <!-- 关联业主 -->
    <amall-select-user
      :visible="visibleUser"
      :id="choiceUserInfo ? [choiceUserInfo.userId] : []"
      @confirmUser="choiceUser"
      @cancel="visibleUser = false"
    ></amall-select-user>
  </div>
</template>

<script>
import wangeDitor from "@/components/tools/wangeditor.vue";
import equmate from "@/components/equmate/index.vue";
import searchProduct from "@/components/searchGoods/index.vue";
import amallSelectUser from "@/components/alerts/amallSelectUser.vue";
import { getPCD } from "@/service/shop.js";
import {
  addOrder,
  getOrderDetail,
  updateOrder,
  addeOrderConstructionStandard,
} from "@/service/order.js";
import { getGoodsDetail, getGoodsAllStandard } from "@/service/goods.js";
import qs from "qs";
const formItemLayout = {
  labelCol: { span: 3 },
  wrapperCol: { span: 20 },
};
const formTailLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 8, offset: 4 },
};

//设备表头
const equipmentColumns = [
  {
    title: "设备名称",
    dataIndex: "name",
    key: "name",
    align: "center",
  },
  {
    title: "型号",
    dataIndex: "model",
    key: "model",
    align: "center",
  },
  {
    title: "数量",
    dataIndex: "count",
    key: "count",
    align: "center",
  },
  {
    title: "单位",
    dataIndex: "unit",
    key: "unit",
    align: "center",
  },
  {
    title: "品牌",
    dataIndex: "brand",
    key: "brand",
    align: "center",
  },
];
const equipmentData = [];

//材料表头
const materialColumns = [
  {
    title: "材料名称",
    dataIndex: "name",
    key: "name",
    align: "center",
  },
  {
    title: "型号",
    dataIndex: "model",
    key: "model",
    align: "center",
  },
  {
    title: "数量",
    dataIndex: "count",
    key: "count",
    align: "center",
  },
  {
    title: "单位",
    dataIndex: "unit",
    key: "unit",
    align: "center",
  },
  {
    title: "品牌",
    dataIndex: "brand",
    key: "brand",
    align: "center",
  },
];
const materialData = [];
export default {
  components: {
    wangeDitor,
    equmate,
    searchProduct,
    // amallSelectService,
    amallSelectUser,
  },
  props: ["btnState", "editRowOrderID"],
  data() {
    return {
      amallShopType: null,
      shoopList: [],
      contractList: [],
      equstate: false,
      formItemLayout,
      formTailLayout,
      options: [],
      editor_value: "",
      previewVisible: false,
      fileList: [], //合同图片
      previewImage: "",
      DrawingsList: [],
      bulidfileList: [], //施工图纸
      choiceUserInfo: [], //关联用户
      third_party_order_source: "4",
      form: this.$form.createForm(this),
      dialogTit: "",
      dialogType: 1,
      selectedid: [],
      visibleUser: false,
      choiceUserInfo: null,

      // 商品选择
      searchShow: false,
      selectedid: [],
      shoopOptions: [],
      // 设备材料清单
      equipmentColumns,
      equipmentData,
      materialColumns,
      materialData,

      from: {
        project_name: null,
        owner_name: null, //业主名称
        mobile: null,
        project_address_id: null, //工程地址
        project_detailed_address: null, //详细地址
        project_introduction: null, //工程简介
        relate_goods: null, //关联商品
        materialList: [], //材料清单
        equipmentList: [], //设备清单
        contract: null, //合同图片
        constructionDrawingsList: [], //施工图纸
        relate_owner: null, // 业主（关联客户）
        relate_third_party_order_id: "", //第三方订单
        third_party_order_source: "", //第三方订单来源
        service_provider_id: "", //服务商ID
        shop_id: "", //商户ID
      },

      relateThirdPartyOrderList: [],
      goodsIDs: [],
      orderID: "",
    };
  },

  created() {},
  mounted() {
    this.getProvinceList().then((res) => {
      this.options = res;
    });
    if (localStorage.getItem("amallSystemId")) {
      this.from.shop_id = localStorage.getItem("amallSystemId");
    }
    this.amallShopType = localStorage.getItem("amallShopType");
    //编辑状态
    if (this.btnState == "edit") {
      // console.log("走编辑");
      this.editProject();
    }
  },
  methods: {
    // 设备材料弹窗
    openEqu() {
      // console.log("商品规格", this.from.relate_goods);
      // console.log("equipmentData", this.equipmentData);
      // console.log("materialData", this.materialData);
      if (this.amallShopType == 1) {
        if (this.equipmentData.length || this.materialData.length) {
          // console.log('走表格数据')
          this.$refs["equmate"].showEditData(
            this.equipmentData,
            this.materialData
          ); //如果设备和材料有数据，则显示
        } else if (this.from.relate_goods) {
          // console.log('走商品规格查找数据');
          this.$refs["equmate"].showAddModal(this.from.relate_goods);
        } //如果有商品规格但是equipmentData或者materialData有值的话
        else {
          // console.log('走空数据');
          this.$refs["equmate"].showAddModal("111111111111111111111111");
        }
      } else {
        if (this.equipmentData.length || this.materialData.length) {
          // console.log('走表格数据')
          this.$refs["equmate"].showEditData(
            this.equipmentData,
            this.materialData
          ); //如果设备和材料有数据，则显示
        } else {
          this.$refs["equmate"].showAddModal("1111111111111111"); //随便写的一个选的规格
        }
      }

      // this.equstate = true;
    },
    closeDialog(data) {
      this.equstate = data;
    },
    getmaterial(data1, data2) {
      // console.log("设备", data1);
      // console.log("材料", data2);
      data1.forEach((item, index) => {
        if (!item.count) {
          data1.splice(index, 1);
        }
      });
      data2.forEach((item, index) => {
        if (!item.count) {
          data2.splice(index, 1);
        }
      });
      this.from.materialList = data2;
      this.from.equipmentList = data1;
      this.equipmentData = data1;
      this.materialData = data2;
    },
    // 省份列表
    getProvinceList(callback = null) {
      return new Promise((resolve, reject) => {
        getPCD({ pid: "" }).then((res) => {
          res.data.forEach((item) => {
            item.isLeaf = false;
          });

          resolve(res.data);
        });
      });
    },
    onChange(value) {},
    // 处理加载城市下级数据（选择、编辑时可用）
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      this.doLoadCityData(targetOption.id, (array) => {
        targetOption.loading = false;
        targetOption.areaList = array;
        this.options = [...this.options];
      });
    },
    doLoadCityData(pid, callback = null) {
      getPCD({ pid }).then((res) => {
        if (res.flag) {
          // 子级数据装到array中
          var array = [];
          let pidLength = pid.toString().length;
          res.data.map((item, index) => {
            array.push(Object.assign(item, { isLeaf: pidLength == 4 }));
          });
          // 再传给回调函数
          if (callback) {
            callback(array);
          }
        }
      });
    },

    // 获取富文本内容
    get_editor_value(value) {
      this.editor_value = value;
    },

    //合同 图片相关
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error("只能上传后缀名 PNG/JPG 的图片!");
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error("图片大小不能超过10MB!");
        return false;
      }
    },

    // 合同图片
    uploadBannerImg({ file, fileList }) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isJpgOrPng || !isLt2M) return;
      this.fileList = fileList;
    },
    //施工图纸
    uploadDrawings(parmams, item) {
      console.log("item", item);
      console.log("parmams", parmams);
      // console.log('fileList', fileList);
      const isJpgOrPng =
        parmams[0].file.type === "image/jpeg" ||
        parmams[0].file.type === "image/png";
      const isLt2M = parmams[0].file.size / 1024 / 1024 < 10;
      if (!isJpgOrPng || !isLt2M) return;
      // this.bulidfileList = fileList;
      item.bulidfileList = parmams[0].fileList;
      // console.log("图纸", this.bulidfileList);
    },
    // 添加施工图纸
    addDrawing() {
      const obj = {
        name: "",
        bulidfileList: this.bulidfileList,
      };
      this.DrawingsList.push(obj);
    },
    handleRemoveDrawings(e) {
      // console.log(e);
      let index = this.fileList.indexOf(e);
      this.bulidfileList.splice(index, 1);
      return false;
    },
    handleRemove(e) {
      let index = this.fileList.indexOf(e);
      this.fileList.splice(index, 1);
      return false;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = file.response.data;
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },

    //商品规格下拉选择
    handleChange(value, i) {
      // console.log("索引", value);
      this.shoopOptions[value] = i[0].key;

      this.from.relate_goods = this.shoopOptions.toString();
      this.equipmentData = [];
      this.materialData = [];
      // console.log("规格选择", this.from.relate_goods);
    },

    addPeople(data) {
      this.dialogTit = "添加商品";
      this.dialogType = 1;

      this.$refs["searchDia"].showModal();
    },
    //选中的商品
    SearchConfirm_compile(data) {
      console.log("选中的值", data);
      this.echoText(data[0].goods_id);
      // this.shoopList = data;
      this.shoopList = this.shoopList.concat(data);
    },

    //简介回显商品简称
    echoText(goodId) {
      getGoodsDetail({ goods_id: goodId }).then((res) => {
        if (res.flag) {
          console.log(res.data, "商品信息");
          if (res.data.goods_abbreviation) {
            this.editor_value = res.data.goods_abbreviation + "<br>";
          }
        }
      });
    },
    // 删除商品
    deleteGoods(data, item) {
      this.editor_value = "";
      this.shoopList.splice(data, 1);

      if (this.shoopList.length == 0) {
        this.from.relate_goods = null;
      } else {
        let a = [];
        item.specList.forEach((x) => {
          if (x.spec_id) {
            a.push(x.spec_id);
          }
        });
        let b = this.shoopOptions;
        for (let i = 0; i <= a.length; i++) {
          for (let x = 0; x <= b.length; x++) {
            if (a[i] == b[x]) {
              b.splice(x, 1);
            }
          }
        }
        this.from.relate_goods = b.join();
      }
    },

    //删除图纸
    deleteDraw(data) {
      this.DrawingsList.splice(data, 1);
    },
    closeAlert(e) {
      this.searchShow = false;
    },

    //绑定业主
    choiceUser(item) {
      this.choiceUserInfo = item;
      // console.log("业主", this.choiceUserInfo);
      this.from.relate_owner = this.choiceUserInfo.userId;
      this.visibleUser = false;
    },
    //下一步 表单提交
    handleSubmit(e) {
      this.from.shop_id = localStorage.getItem("amallSystemId");
      // console.log("shop", this.orderSn);
      //处理合同
      // console.log("合同", this.fileList);
      if (this.btnState == "edit") {
        this.fileList.forEach((item) => {
          if (item.response) {
            this.contractList.push(item.response.data);
          } else {
            this.contractList.push(item.url);
          }
        });
        // console.log("编辑合同", this.contractList);
        this.from.contract = this.contractList.join(",");
      } else if (this.from.relate_owner) {
        this.fileList.forEach((item) => {
          this.contractList.push(item.response.data);
        });
        // console.log("新增合同", this.contractList);
        this.from.contract = this.contractList.join(",");
      }

      //处理图纸
      // console.log("图纸", this.DrawingsList);
      if (this.btnState == "edit") {
        this.DrawingsList.forEach((item) => {
          if (item.bulidfileList.length) {
            if (item.bulidfileList[0].response) {
              item.img = item.bulidfileList[0].response.data;
            } else {
              item.img = item.bulidfileList[0].url;
            }
          } else {
            this.$message.warning("请上传图纸");
          }
          if (item.name) {
          } else {
            this.$message.warning("请输入图纸名称");
          }
        });
        this.from.constructionDrawingsList = this.DrawingsList;
        // console.log("编辑处理完图纸", this.from.constructionDrawingsList);
      } else {
        this.DrawingsList.forEach((item) => {
          if (item.bulidfileList.length) {
            item.img = item.bulidfileList[0].response.data;
          } else {
            this.$message.warning("请上传图纸");
          }
          if (item.name) {
          } else {
            this.$message.warning("请输入图纸名称");
          }
        });
        const b = this.DrawingsList;
        // b.forEach((item) => {
        //   delete item.bulidfileList;
        // });
        this.from.constructionDrawingsList = b;
        // console.log("新增处理完图纸", this.from.constructionDrawingsList);
      }

      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log("表单数据", values);

          if (this.from.relate_owner == null && this.btnState !== "edit") {
            this.$message.warning("请先关联客户");
            return;
          }
          //处理关联商品
          if (this.btnState !== "edit") {
            if (this.shoopList.length) {
              if (this.from.relate_goods == null) {
                this.$message.warning("请选择关联商品规格");
                return;
              }
            }
          }
          if (!this.editor_value) {
            this.$message.warning("请输入工程简介");
            return;
          }
          // if (this.from.third_party_order_source == "") {
          //   this.$message.warning("请选择订单");
          //   return;
          // }
          this.from.project_name = values.projectName;
          this.from.owner_name = values.userName;
          this.from.mobile = values.phone;
          this.from.project_address_id = values.projectLocation.join(",");
          this.from.project_detailed_address = values.project_detailed_address;
          this.from.project_introduction = this.editor_value;
          this.from.relate_third_party_order_id = values.order_id;
          this.from.third_party_order_source = this.third_party_order_source;
          // console.log("状态", this.btnState);
          if (this.btnState == "edit") {
            this.from.order_id = this.editRowOrderID;
            updateOrder(this.from).then((res) => {
              if (res.flag) {
                this.$message.success("修改成功");
                this.$emit("close");
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            addOrder(this.from).then((res) => {
              if (res.flag) {
                console.log("第一步", res.data);
                this.orderID = res.data;
                const data2 = res.data;
                //this.getProjectGoods(res.data); //后端直接根据商品配置默认配置
                window.localStorage.setItem("order", res.data);
                this.$message.success("创建成功，为你跳转到安排施工任务");

                this.$emit("changeSteps", 2);
              } else {
                this.$message.error(res.message);
              }
            });
          }
        }
      });
    },
    //--------------------------------根据工程绑定的商品默认设置施工标准--------------------------------
    //工程创建成功之后查询工程绑定的商品
    getProjectGoods(proId) {
      getOrderDetail({ order_id: proId }).then((res) => {
        if (res.flag) {
          res.data.relateGoodsList.forEach((item) => {
            this.goodsIDs.push(item.goods_id);
          });
          this.getGoodsStand();
          console.log(this.goodsIDs, "集合商品ID");
        } else {
          this.$message.error(res.message);
        }
      });
    },

    //获取关联商品施工标准列表
    getGoodsStand() {
      let data = this.goodsIDs.toString();
      getGoodsAllStandard({ goodsIdList: data }).then((res) => {
        if (res.flag) {
          console.log("关联商品标准模版", res.data);
          if (res.data.length) {
            //筛选出每个中的standard_id
            let standardIDs = [];
            res.data.forEach((item) => {
              standardIDs.push(item.standard_id);
            });
            this.addProjectStandard(standardIDs);
          } else {
            console.log("没有设置关联商品施工标准，不走设置规范接口");
          }
        }
      });
    },
    //添加施工标准（规范）
    addProjectStandard(data) {
      addeOrderConstructionStandard(
        qs.stringify({
          order_id: this.orderID,
          standardIdList: data.join(","),
        })
      ).then((res) => {
        if (res.flag) {
          console.log("添加", res.data);
          console.log("添加施工标准成功");
        } else {
          this.$message.error(res.message);
        }
      });
    },

    //----------------------------------------------------------------------------------------------

    //编辑省市区
    getPosition(id) {
      let province_id = id.split(",")[0],
        city_id = id.split(",")[1],
        area_id = id.split(",")[2];
      this.options.forEach((item, index) => {
        if (item.id == province_id) {
          this.doLoadCityData(province_id, (area) => {
            area.forEach((it, idx) => {
              if (it.id == city_id) {
                this.doLoadCityData(city_id, (reslute) => {
                  area[idx].areaList = reslute;
                  this.options[index].areaList = area;
                  this.form.setFieldsValue({
                    projectLocation: [
                      parseInt(province_id),
                      parseInt(city_id),
                      parseInt(area_id),
                    ],
                  });
                });
              }
            });
          });
        }
      });
    },

    // 对上传成功返回的数据进行格式化处理，格式化a-upload能显示在已上传列表中的格式（这个格式官方文档有给出的）
    fileFormatter(data) {
      let file = {
        uid: data.uuid, // 文件唯一标识，建议设置为负数，防止和内部产生的 id 冲突
        name: data.name, // 文件名
        status: "done", // 状态有：uploading done error removed
        url: data.preview,
      };
      return file;
    },
    //编辑表单
    editProject() {
      getOrderDetail({ order_id: this.editRowOrderID }).then((res) => {
        if (res.flag) {
          // console.log("编辑详情", res.data);
          this.relateThirdPartyOrderList = res.data.relateThirdPartyOrderList;
          this.getPosition(res.data.project_address_id);
          const data = res.data;
          this.form.setFieldsValue({
            projectName: data.project_name,
            userName: data.owner_name,
            phone: data.mobile,
            project_detailed_address: data.project_detailed_address,
            order_id: data.relate_third_party_order_id,
          });
          this.editor_value = data.project_introduction;
          this.third_party_order_source = data.third_party_order_source;
          //处理合同
          if (data.contract == "") {
            this.fileList = [];
          } else {
            let arr = [];
            data.contract.split(",").forEach((item, index) => {
              let obj = this.fileFormatter({
                uuid: index,
                name: "第" + index + 1 + "轮播图",
                preview: item,
                response: { data: item },
              });
              arr.push(obj);
            });
            this.fileList = arr;
          }

          // 施工图纸
          this.DrawingsList = data.constructionDrawingsList;
          this.DrawingsList.forEach((item, index) => {
            item.bulidfileList = [];
            let obj = this.fileFormatter({
              uuid: index,
              name: "第" + index + 1 + "轮播图",
              preview: item.img,
              response: { data: item.img },
            });
            item.bulidfileList.push(obj);
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.drawings {
  margin-left: 104px;
  display: flex;
  flex-wrap: wrap;
  margin-right: 94px;
  margin-top: 10px;
  justify-content: start;
  .ant-input {
    width: 160px;
  }
}
.ant-form-item {
  margin-bottom: 10px !important;
}
.equstyle {
  height: 300px;
  overflow-y: auto;
}
.shopBox {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 20px;
  width: 308px;
  background-color: #f5f5f5;
  border-radius: 5px;
  position: relative;
}
.delete {
  position: absolute;
  top: 0;
  left: 0;
  width: 16px;
  height: 16px;
  color: #fff;
  background: #000000;
  text-align: center;
  line-height: 16px;
  opacity: 0.2;
  border-radius: 5px 0px 5px 0px;
}
.shopRight {
  width: 166px;
  display: flex;
  flex-direction: column;
  justify-content: inherit;
}
.shopContent {
  display: flex;
  margin-left: 104px;
  width: 636px;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-right: 28px;
}
.drawBox {
  width: 292px;
  height: 176px;
  padding: 15px;
  box-sizing: border-box;
  background: #f7f7f7;
  position: relative;
  margin-bottom: 20px;
  margin-right: 20px;
}
.delete:hover {
  cursor: pointer;
}

.deletedrawings {
  position: absolute;
  top: 0;
  left: 0;
  width: 16px;
  height: 16px;
  color: #fff;
  background: #000000;
  text-align: center;
  line-height: 16px;
  opacity: 0.2;
  border-radius: 5px 0px 5px 0px;
}
.deletedrawings:hover {
  cursor: pointer;
}
.drawBox >>> .ant-upload.ant-upload-select-picture-card {
  width: 160px;
}
.drawBox >>> .ant-upload-list-picture-card .ant-upload-list-item {
  width: 160px;
}
</style>



// WEBPACK FOOTER //
// src/components/createProject/index.vue